export const OPEN_AUTH_MODAL_EVENT = "open-auth-modal";

export type OpenAuthModalDetail = {
  mode?: "signin" | "signup";
};

export function openAuthModal(detail: OpenAuthModalDetail = { mode: "signup" }) {
  window.dispatchEvent(new CustomEvent<OpenAuthModalDetail>(OPEN_AUTH_MODAL_EVENT, { detail }));
}
